import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';
import SortTree from './sort-tree.vue';
import hotkeys from 'hotkeys-js';
import ContextMenu from '@ps/components/context-menu/index.vue';
import { getBaseResourceType } from '@/store/creative/common/resource';
import categoryBox from './category-box.vue';
import { newTreeItem, switchParent, getRootNode, findById, getDescendants, isGroup, isLimitPlayItem, isPresetCategory, isGameConfigGroup } from './tree.js';
import { cookGameConfigResourceByCategory } from '@/store/creative/common/game-config';
import { gameConfigCategoryResourceType } from '@/store/creative/common/category';

export default {
  props: {
    categoryType: [String, Number]
  },
  components: {
    SortTree: SortTree,
    ContextMenu: ContextMenu,
    categoryBox: categoryBox
  },
  data: function data() {
    return {
      sortType: 1,
      innerData: [],
      expandList: {},
      list: {},
      playList: {},
      activeNodes: [],
      menuVisible: false,
      dragOver: '',
      dragStartTree: '',
      defaultExpandedMap: []
    };
  },
  mounted: function mounted() {
    this.sortType = this.categoryType;
    hotkeys('command,ctrl', {
      keydown: true,
      keyup: true
    });
  },
  destroyed: function destroyed() {
    hotkeys.unbind();
  },

  methods: _extends({}, mapMutations({
    updateSortMenuDialog: 'creative/template/updateSortMenuDialog',
    updateOutlineCategory: 'creative/template/updateOutlineCategory'
  }), {
    initContextMenu: function initContextMenu(_ref) {
      var _this = this;

      var menuList = _ref.menuList,
          event = _ref.event;

      this.menuVisible = true;
      this.$nextTick(function () {
        _this.$refs.contextMenu.init({ menuList: menuList, event: event });
      });
    },
    handleDragTreeEnd: function handleDragTreeEnd(event, treeName) {
      console.log('树结束');
      // this.$nextTick(() => {
      //   this.updateAllTreeData(this.innerData)
      // })
    },
    handleDragTreeEnter: function handleDragTreeEnter(treeName) {
      this.dragOver = treeName;
    },
    handleDragStart: function handleDragStart(node, event, treeName) {
      var _this2 = this;

      if (this.dragOver) {
        return;
      }
      this.dragOver = treeName;
      this.dragStartTree = treeName;
      var treeList = ['categoryTree', 'playTree', 'expandTree'];
      treeList.forEach(function (tree) {
        if (tree !== treeName) {
          _this2.getRefTree(tree).$emit('tree-node-drag-start', event, { node: node });
        }
      });
    },
    getRefTree: function getRefTree(treeName) {
      if (treeName === 'expandTree') {
        return this.$refs['expandList'].$refs['tree'];
      }
      if (treeName === 'playTree') {
        return this.$refs['playList'].$refs['tree'];
      }
      return this.$refs['categoryList'].$refs['tree'];
    },
    getListByName: function getListByName(treeName) {
      if (treeName === 'expandTree') {
        return this.expandList;
      }
      if (treeName === 'playTree') {
        return this.playList;
      }
      return this.list;
    },
    handleDragEnd: function handleDragEnd(draggingNode, endNode, position, event, treeName) {
      if (this.dragOver !== this.dragStartTree) {
        this.getRefTree(this.dragOver).$emit('tree-node-drag-end', event);
      }
      this.dragOver = '';
    },


    // 设置默认展开场景节点uuid
    setExpandedData: function setExpandedData(node) {
      var ids = [];
      var allNodes = getDescendants(node, false, false).filter(function (item) {
        return item.id;
      });
      allNodes.forEach(function (node) {
        if (node.sub_category && node.sub_category.length > 0 && !isPresetCategory(node)) {
          ids.push(node.id);
        }
      });
      this.defaultExpandedMap = ids;
    },
    updateExpandedData: function updateExpandedData(id) {
      var ids = this.defaultExpandedMap;
      if (ids.indexOf(id) !== -1) {
        _.remove(ids, function (val) {
          return val === id;
        });
        this.defaultExpandedMap = ids;
      } else {
        ids.push(id);
        this.defaultExpandedMap = ids;
      }
    },
    handleNodeExpand: function handleNodeExpand(item) {
      this.updateExpandedData(item.id);
    },
    handleDragOver: function handleDragOver(draggingNode, dropNode, event, treeName) {
      this.dragOver = treeName;
    },
    handleMenuCancel: function handleMenuCancel() {
      this.menuVisible = false;
    },
    handleMenu: function handleMenu(_ref2) {
      var menu = _ref2.menu,
          event = _ref2.event,
          node = _ref2.node;

      this.initContextMenu({
        menuList: menu,
        event: event
      });
    },
    getRefCategory: function getRefCategory(category) {
      var baseResourceType = getBaseResourceType(category.resource_type);
      return _.get(this.templateConfig, ['category_ref', baseResourceType, category.prefix], []);
    },
    handleCreate: function handleCreate(data, treeName) {
      var _this3 = this;

      if (this.activeNodes.length === 0) {
        this.$message.warning('请选中需要打组元素');
        return;
      }
      var isSelectedStage = this.activeNodes.filter(function (item) {
        return item.pid === 1;
      }).length > 0;
      var isSelectedScene = this.activeNodes.filter(function (item) {
        return item.pid === 9;
      }).length > 0;
      var isSelectedGroup = this.activeNodes.filter(function (item) {
        return isGroup(item);
      }).length > 0;
      var isSelectedLimitPlayItem = this.activeNodes.filter(function (item) {
        return isLimitPlayItem(item);
      }).length > 0;
      // 是否预设分类
      var hasPresetCategory = this.activeNodes.filter(function (item) {
        return isPresetCategory(item);
      }).length > 0;
      var isSelectedGameconfigGroup = this.activeNodes.filter(function (item) {
        return isGameConfigGroup(item) || findById(_this3.innerData, item.pid).resource_type === 'gameConfig';
      }).length > 0;
      if (isSelectedStage) {
        this.$message.warning('无法对关键元素节点进行打组');
        return;
      }
      if (hasPresetCategory) {
        this.$message.warning('无法对预设节点进行打组');
        return;
      }
      if (isSelectedScene) {
        this.$message.warning('无法对场景节点进行打组');
        return;
      }
      if (isSelectedGroup) {
        this.$message.warning('无法对组节点进行打组');
        return;
      }
      if (isSelectedGameconfigGroup) {
        this.$message.warning('无法对固有玩法组进行打组');
        return;
      }
      if (isSelectedLimitPlayItem) {
        this.$message.warning('无法对通用玩法进行打组');
        return;
      }
      if (treeName === 'playTree' && this.activeNodes.some(function (node) {
        return node.resource_type !== gameConfigCategoryResourceType;
      })) {
        this.$message.warning('玩法分类下打组内容必须全部为玩法');
        return;
      }
      // if (!this.activeNodes.every(item => findById(data, item.id))) {
      //   this.$message.warning('无法跨分类打组')
      //   return
      // }
      if (this.activeNodes.length) {
        var getElementNodes = function getElementNodes(nodes) {
          var temp = [];
          nodes.forEach(function (node) {
            if (isGroup(node)) {
              temp = temp.concat(node.sub_category);
            } else {
              temp.push(node);
            }
          });

          // 根据id过滤重复节点
          temp = _.uniqBy(temp, 'id');

          // 排序
          var sortList = getDescendants(_this3.innerData);

          var compare = function compare() {
            return function (a, b) {
              var val1 = sortList.findIndex(function (item) {
                return item.id === a.id;
              });
              var val2 = sortList.findIndex(function (item) {
                return item.id === b.id;
              });
              return val1 - val2;
            };
          };

          return temp.sort(compare());
        };

        var nodes = getElementNodes(this.activeNodes);
        // 打组节点是否在关联组中
        var hasRefCategory = nodes.some(function (node) {
          var parent = findById(_this3.innerData, node.pid);
          return isGroup(parent) && _this3.getRefCategory(parent).length > 1;
        });
        if (hasRefCategory) {
          this.$message.warning('关联组节点的元素，无法参与打组');
          return;
        }
        var treeDesc = getDescendants(this.getListByName(treeName));
        var pointNode = getRootNode({
          tree: this.innerData,
          node: nodes.filter(function (item) {
            return treeDesc.map(function (el) {
              return el.id;
            }).indexOf(item.id) !== -1;
          })[0]
        });
        var parent = findById(this.innerData, pointNode.pid);
        var index = parent.sub_category.findIndex(function (item) {
          return item.id === pointNode.id;
        });
        this.addGroup(nodes, parent, index);
        this.activeNodes.forEach(function (node) {
          if (isGroup(node)) {
            var cParent = findById(_this3.innerData, node.pid);
            cParent.sub_category.splice(cParent.sub_category.findIndex(function (item) {
              return item.id === node.id;
            }), 1);
          }
        });
        this.handleUpdateList(this.innerData);
      }
    },
    addGroup: function addGroup(nodes, target, index) {
      var newGroup = newTreeItem(target.id);
      target.sub_category.splice(index, 0, newGroup);
      switchParent({
        nodes: nodes,
        index: 0,
        target: newGroup,
        tree: this.innerData
      });
      // 默认展开打组内容
      this.handleNodeExpand(newGroup);
      this.handleUpdateList(this.innerData);
      return newGroup;
    },
    handleUpdateList: function handleUpdateList(data) {
      this.updateAllTreeData(data);
      //
    },
    updateAllTreeData: function updateAllTreeData(data) {
      // 1: 元素
      this.list = this.cookList(data, 1);
      // 3: 玩法
      this.playList = this.cookList(data, 3);
      // 4: 扩展内容
      this.expandList = this.cookList(data, 4);
    },
    handleUpdateActive: function handleUpdateActive(node) {
      this.menuVisible = false;
      // 禁止选中通用玩法
      if (isLimitPlayItem(node.data)) return;
      var isMultiple = hotkeys.isPressed('command') || hotkeys.isPressed('ctrl');
      var activeNode = findById(this.innerData, node.data.id);
      if (isMultiple) {
        if (this.activeNodes.some(function (item) {
          return item.id === activeNode.id;
        })) {
          this.activeNodes = this.activeNodes.filter(function (item) {
            return item.id !== activeNode.id;
          });
        } else {
          this.activeNodes = _.uniqBy([].concat(_toConsumableArray(this.activeNodes), [activeNode]), 'id');
        }
      } else {
        this.activeNodes = [activeNode];
      }
    },
    cookList: function cookList(data, sortType) {
      var selectedData = data.find(function (item) {
        return item.id === sortType;
      });
      var hasCategory = selectedData && selectedData.sub_category && selectedData.sub_category.length;
      if (hasCategory) {
        var list = _.cloneDeep(selectedData);
        list.sub_category = list.sub_category.filter(function (item) {
          return item.id !== 9999;
        });
        return list;
      }
      if (selectedData) {
        return selectedData;
      }
      return data;
    },
    handleTabClick: function handleTabClick(tab) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.sortType = Number(tab.id, 10);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    closeDialog: function closeDialog() {
      this.updateSortMenuDialog({
        visible: false
      });
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var templateConfig, newGameConfigResource;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.updateTree(_this5.list);
                _this5.updateTree(_this5.playList);
                _this5.updateTree(_this5.expandList);
                templateConfig = _.cloneDeep(_this5.templateConfig);

                templateConfig.category.forEach(function (item, index) {
                  _this5.innerData.forEach(function (el) {
                    if (item.id === el.id) {
                      templateConfig.category[index] = el;
                    }
                  });
                });
                _context2.next = 7;
                return _this5.$store.dispatch('creative/template/updateTemplateInfo', templateConfig);

              case 7:
                _context2.next = 9;
                return _this5.$store.dispatch('creative/template/rebuildCategory');

              case 9:
                if (_this5.gameConfigResource) {
                  newGameConfigResource = cookGameConfigResourceByCategory({
                    categoryList: _this5.templateConfig.category,
                    gameConfigResource: _this5.gameConfigResource,
                    hasInitGameConfigCategory: true
                  });

                  _this5.$store.commit('creative/template/updateGameConfigResource', newGameConfigResource);
                }
                _this5.updateOutlineCategory();
                _this5.closeDialog();
                // console.log('更新引导菜单')

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    updateTree: function updateTree(list) {
      var temp = _.cloneDeep(list);
      var updatePid = function updatePid(li) {
        if (li.sub_category && li.sub_category.length > 0) {
          li.sub_category.forEach(function (item, i) {
            if (item.pid !== li.id && li.resource_type !== 'group') {
              item.pid = li.id;
            }
            updatePid(item);
          });
        }
      };
      // 保证排序数据子节点pid等于父节点id
      updatePid(temp);
      var target = _.cloneDeep(this.innerData);
      target.forEach(function (item, index) {
        if (item.id === temp.id) {
          target[index] = temp;
        }
      });
      this.innerData = target;
    }
  }),
  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    sortMenuDialog: function sortMenuDialog(state) {
      return state.creative.template.sortMenuDialog;
    },
    gameConfigResource: function gameConfigResource(state) {
      return state.creative.template.gameConfigResource;
    }
  })),
  watch: {
    'sortMenuDialog.visible': function sortMenuDialogVisible(val) {
      if (val) {
        var temp = _.cloneDeep(this.templateConfig.category);
        temp.forEach(function (item) {
          if (!item.sub_category) {
            item.sub_category = [];
          }
        });
        this.innerData = temp;
        this.updateAllTreeData(this.innerData);
        this.activeNodes = [];
        this.defaultExpandedMap = [];
        this.setExpandedData({
          sub_category: this.innerData
        });
      }
    },
    sortType: function sortType(val) {
      this.updateTree(this.list);
      this.list = this.cookList(this.innerData, this.sortType);
    }
  }
};